<template>
	<div class="intro">

		<MainColumn class="center">
			<div class="wrap">
				<div id="do"></div>
				<Logo size="home" />
				<Loading v-if="loading"/>
				<div class="difficulty">
					<span class="size-xs">Modalità</span>
					<Switcher v-on:update-value="changeDifficulty" val1="Facile" val2="Difficile" :active="$store.state.difficulty" />
				</div>
				<div class="buttons">
					<Button value="Scrivi la tua storia" color="yellow" @click.native="goto('gioca')"/>
					<Button value="Condividi carte" color="cyan" @click.native="goto('prepara')"/>

					<Button color="white" :secondary="true" value="Regole" :double="true" @click.native="rulesDialog = true" />
					<div @click="creditsDialog = true" class="credits">Crediti</div>
				</div>

				<v-dialog v-model="creditsDialog" transition="dialog-bottom-transition" max-width="720px">
					<div class="card">
						<h2>Crediti</h2>
						<div class="content">
							<div class="label">Progettazione</div>
							<div class="value">Fabio Ferri, Simona Ravalico</div>
							<div class="label">Design e sviluppo</div>
							<div class="value">QZR studio, Lucca</div>
						</div>
					</div>
				</v-dialog>

				<v-dialog v-model="rulesDialog" transition="dialog-bottom-transition" max-width="720px">
					<div class="card">
						<h2>Regole</h2>
						<div class="label">Come si gioca?</div>
						<div class="content">
							<div class="rule-section">
								<div class="image">
									<img src="@/assets/rules/regolestorie01.png" />
								</div>
								<div class="text">
									<p>Crea la tua storia a partire dalle parole che ti forniamo: scatena la tua creatività associando	parole e concetti che solo in apparenza potrebbero sembrarti distanti fra loro!</p>
								</div>
							</div>

							<div class="rule-section">
								<div class="image">
									<img src="@/assets/rules/regolestorie02.png" />
								</div>
								<div class="text">
									La <b><span class="water--text">carta verde</span></b> si riferisce al primo personaggio della tua storia. Qui, ad esempio, la descrizione del tuo personaggio dovrà contenere le parole ‘<span class="water--text">armonia</span>’ e ‘<span class="water--text">danno</span>’ (<i><span class="water--text">“C’era una volta un giovane uomo che viveva in un bosco, in armonia con la natura che lo circondava e attento a non arrecare danno a nessuna delle creature che abitavano attorno a lui”</span></i>). Quando poi descriverai un suo dialogo dovrai inserire la parola ‘<span class="water--text">tiramisù</span>’ e ‘<span class="water--text">bene</span>’ e così via.
								</div>
							</div>

							<div class="rule-section">
								<div class="image">
									<img src="@/assets/rules/regolestorie03.png" />
								</div>
								<div class="text">
									Nella modalità difficile troverai le parole che caratterizzeranno anche il <span class="pink--text">secondo personaggio!</span><br><br>
									Per descrivere il luogo e tempo in cui si svolge il tuo racconto usa le parole della <b><span class="blue--text text--darken-3">carta blu!</span></b> (<i><span class="blue--text text--darken-3">“La radura era alberata e crescevano parecchi lamponi nei cespugli lì attorno…”</span></i>)<br><br>
									In più ti sfidiamo a usare una serie di <span class="orange--text">espressioni</span> o frasi fatte tipiche della nostra lingua.
								</div>
							</div>

							<div class="rule-section">
								<div class="image">
									<img src="@/assets/rules/regolestorie04.png" />
								</div>
								<div class="text">
									Man mano che scriverai il tuo racconto potrai vedere quali e quante parole hai usato.<br><br>
									Una volta arrivato alla fine potrai scaricare il tuo testo con un semplice clic sul tasto scarica. <img class="download-icon" src="@/assets/rules/download.png" />
								</div>
							</div>

							<div class="rule-section">
								<div class="image">
									<img src="@/assets/rules/regolestorie05.png" />
								</div>
								<div class="text">
									È possibile <b>condividere le carte</b> attraverso un semplice link.
								</div>
							</div>

						</div>
					</div>
				</v-dialog>
			</div>
		</MainColumn>
	</div>
</template>

<script>
import MainColumn from '@/components/MainColumn.vue';
import Button from '@/components/Button.vue';
import Switcher from '@/components/Switcher.vue';
import Logo from '@/components/Logo.vue';
import Loading from '@/components/Loading.vue';

export default {
	components: {
		MainColumn,
		Button,
		Switcher,
		Logo,
		Loading
	},
	data() {
		return {
			animation: false,
			loading: false,
			creditsDialog: false,
			rulesDialog: false
		}
	},
	mounted() {
		for (let sound in this.$store.state.sounds) {
			this.$store.state.sounds[sound].pause();
			this.$store.state.sounds[sound].currentTime = 0;
			this.$store.state.sounds[sound].playbackRate = 1;
		}
		this.updateProperty({
			property: "backgroundColor",
			value: 'blue'
		});
		this.resetAllCards();
		this.pickRandomWords();
	},
	methods: {
		goto(page) {
			this.$router.push('/'+page)
		},
		changeDifficulty(val) {
			this.updateProperty({
				property: "difficulty",
				value: val
			});
			
			this.loading = true;
			
			setTimeout(() => {
				this.loading = false;
			},500);			
		}
	}
}
</script>
<style scoped lang="scss">
	#do {
		width: 11%;
		aspect-ratio: 779/498;
		margin-bottom: -8.1rem;
		background-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 779 497.9' style='enable-background:new 0 0 779 497.9;' xml:space='preserve'%3E%3Cpath fill='%23FFFFFF' d='M779,251.8c-2.9,82-35.1,152.1-104.3,203.2c-30.6,22.6-65.1,36.8-102.9,40.5c-99.4,9.6-175.2-30.6-226.6-114.5 c-62.8-102.4-43.4-237.5,43.2-318.3C425,28.5,468.1,7.2,518.1,2.1c74.6-7.7,138.3,16.5,190.2,70.2c41.2,42.6,63.3,94.4,69.2,153.2 C778.4,233.2,778.4,241.1,779,251.8z M350,237.9c0,35.2,3.8,59,11.9,82c20.4,57.6,57.6,100.3,114.7,123.3 c70.9,28.6,152.2,8.8,203.8-48c57.1-62.9,73.5-152.5,39.4-230.5C687.7,91,632,47.2,549.8,42.4c-41.7-2.4-79.9,9.8-113.4,34.5 C378.7,119.4,352.1,178.1,350,237.9z'/%3E%3Cpath fill='%23FFFFFF' d='M0,497.9c0-14.4,0-27.7,0-41.6c5.5-0.3,11-0.3,16.4-1c80-10,134.3-54.5,162.1-128.4 c31.1-82.9,16.2-159.5-43.5-225.6C104,67,64.3,48,18.2,42.8c-5.9-0.7-11.9-0.7-18.1-1c0-13.8,0-27.2,0-41.8 c11.7,1.1,23.2,1.2,34.4,3.3c17,3.2,68.3,12.3,116.3,53.9c46,39.8,62.9,86.3,70,106.6c4.4,12.6,12.9,40.2,14.4,76.5 c1.4,32.4-3.4,56.8-4.6,62.3c-14.4,69.8-57,113.4-70.4,127.3c-36.2,37.9-81.7,59.6-134.1,65.9C17.7,496.9,9.1,497.2,0,497.9z'/%3E%3C/svg%3E%0A");
	}
	.center {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: calc(100vh - #{px(30)} );
		.wrap {
			width: px(400);
			margin-top: px(-50);
			@include breakpoint(s) {
				width: 90%;
			}
			.logo {
				margin-bottom: px(50);
			}
			.difficulty {
				align-items: center;
				color: #fff;
				text-transform: uppercase;
				display: flex;
				margin-bottom: px(20);
				& > * {
					flex-basis: 50%;
				}
			}
			.buttons {
				display: block;
				width: 100%;
				margin: auto;
				& > * {
					width: 100%;
					margin-bottom: px(20);
				}
			}
		}
	}
	.card {
		padding: 1rem;
		border-radius: 1.5rem;
		background: white;
		overflow: auto;
		color: $blue;
		.content {
			max-height: calc(100vh - 20rem);
			overflow-y: auto;

			.rule-section {
				display: flex;
				flex-wrap: nowrap;
				align-items: center;
				padding: 1rem 0;
				@include breakpoint(s) {
					flex-wrap: wrap;
					padding-bottom: 2rem;
				}

				.image {
					flex-basis: 40%;
					text-align: center;
					@include breakpoint(s) {
						flex-basis: 100%;
					}

					img {
						width: 80%;
						@include breakpoint(s) {
							width: 50%;
						}
					}
				}
				.text {
					flex-basis: 60%;
					padding-right: 1rem;
					@include breakpoint(s) {
						padding-top: 1rem;
						flex-basis: 100%;
					}

					.download-icon {
						vertical-align: -2rem;
						transform: translate(-10px,-10px);
						@include breakpoint(s) {
							width: 40px;
							transform: translate(-5px,-12px);
						}
					}
				}
			}
		}
	}

	.label {
		text-transform: uppercase;
		font-weight: bold;
		margin-top: 1rem;
		margin-bottom: 1rem;
		background: $blue;
		color: white;
		border-radius: 1rem;
		text-align: center;
	}

	.value {
		border-bottom: 0.1rem dotted;
	}

	.credits {
		position: fixed;
		bottom: 1rem;
		left: 50%;
		transform: translateX(-50%);
		display: inline-block;
		color: white;
		font-size: $xs;
		text-transform: uppercase;
		cursor: pointer;
		text-align: center;
	}

</style>